import { NGXAjax } from '../../common/Services/AjaxService';
import { ApiUtils } from '../../common/api';
import FormModel from './form-model';
import FormCollection from './form-collection';

/**
 * Function will load in ONE form, for the given formId
 * to be used in Macro experiences, to load in the assigned form
 * @param formId - id of the form to be fetched
 */
function fetchExperienceForm(formId) {
  return NGXAjax.get(`/api/form/show.json?id=${formId}&typeRef_filter=type.asset.form&offset=0&max=1`)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(FormCollection.deserialize);
}

/**
 * Function will load in all forms that can be selected in an experience(when selecting another form).
 * This will return experience forms and library forms too, that are available for the given parameters
 * @param containerRef
 * @param typeRef
 * @param subTypeRef
 */
function fetchContainerForms(containerRef, typeRef = '', subTypeRef = '') {
  return NGXAjax.get('/api/form/list.json', {
    campaignType_filter:    typeRef,
    campaignSubtype_filter: subTypeRef,
    containerRef_filter:    containerRef,
    libAndContainer:        true,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(FormCollection.deserialize);
}

/**
 * function will fetch in library forms, starting at 'offset' and loading in 'max' number of forms
 * @param offset
 * @param max
 */
function fetchLibraryForms(offset, max, typeRef = '', subTypeRef = '') {
  return NGXAjax.get(
    `/api/form/list.json?onlyLibItems=true&offset=${offset}&max=${max}&sort=lastUpdated&order=DESC&campaignType_filter=${typeRef}&campaignSubtype_filter=${subTypeRef}`
  )
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(FormCollection.deserialize);
}

/**
 * Function will persist ONE form
 * the form update api only supports saving ONE form, and that's fine for the current usage, as we are only going to have ONE form inside SD to save.
 * @param forms
 */
function saveForms(forms) {
  return NGXAjax.post('/api/form/update.json', FormModel.serialize(forms[0]), undefined)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(FormCollection.deserialize);
}

/**
 * function will create a new form using the given 'form' parameter
 */
function createNewForm(form) {
  return NGXAjax.post('/api/form/save.json', FormModel.serialize(form, true))
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(FormCollection.deserialize);
}

function cloneIntoCampaign(formId, experienceId) {
  return NGXAjax.post(`/api/form/cloneIntoCampaign/${formId}.json`, {
    assignTo:         'campaign',
    campaignObjectId: experienceId,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(FormModel.deserialize);
}

export default {
  fetchExperienceForm,
  fetchContainerForms,
  fetchLibraryForms,
  saveForms,
  createNewForm,
  cloneIntoCampaign,
};
